import API from '../api-service.js';
import axios from 'axios';

const baseUri = 'profile';

export default {
  getUserImageS3Info(body) {
    return API.put(`${baseUri}/image`, body).then(res => res);
  },
  getUserImage() {
    return API.get(`${baseUri}/image`).then(res => res);
  },
  updateUserImage(response, image, options) {
    return axios.put(response, image, options);
  },
};
